import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs/BehaviorSubject";

@Injectable()
export class GlobalLoaderService {

    private loading = new BehaviorSubject(false);
    constructor() { }

    setLoading(status: boolean) {
        return this.loading.next(status);
    }

    getLoading() {
        return this.loading.asObservable();
    }
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/services/global-loader.service.ts